var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 946,
    height: 946,
    viewBox: "0 0 946 946",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter0_f_1150_125)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 473,
    cy: 473,
    r: 173,
    fill: "url(#paint0_linear_1150_125)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1150_125",
    x: 0,
    y: 0,
    width: 946,
    height: 946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_1150_125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1150_125",
    x1: 473,
    y1: 300,
    x2: 473,
    y2: 646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#529ED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453CA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightEllipse);
export default __webpack_public_path__ + "static/media/rightEllipse.b3feb7f83fd48b134cdd7abfdc63d1f3.svg";
export { ForwardRef as ReactComponent };